import { render } from "./AdminDelete.vue?vue&type=template&id=0e18d096"
import script from "./AdminDelete.vue?vue&type=script&lang=js"
export * from "./AdminDelete.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__